import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '@app/core/i18n.service';
import { environment } from 'src/environments/environment';


interface ErrorsDetails {
  title: string
  description: string,
  login: boolean
}

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
})
export class ErrorPageComponent implements OnInit {
  errorCode: number = 0;  
  localizedBadReq: string = $localize`:Bad Request Title text|Message header displayed when there is a bad request@@appbadRequestInErrorPage:Bad Request`;
  localizedBadReqDesc: string = $localize`:Bad Request description text|Message displayed when there is a bad request@@appbadRequestDescInErrorPage:Your request resulted in an error. Try going back to previous page.`;

  localizedUnAuthor: string = $localize`:UnAuthorized Title text|Message header displayed when there is a Un-Authorized access@@appUnAuthorInErrorPage:Unauthorized`;
  localizedUnAuthorDesc: string = $localize`:UnAuthorized description text|Message displayed when there is a UnAuthorized access@@appUnAuthorDescInErrorPage:Sorry, your request could not be processed. Authentication is required to access this page. Reload the page to try again. `;

  localizedAccessDenied: string = $localize`:Access Denied Title text|Message header displayed when there is a access denied@@appAccDeniedInErrorPage:Access Denied/Forbidden`;
  localizedAccessDeniedDesc: string = $localize`:Access Denied description text|Message displayed when there is a access denied@@appAccDeniedDescInErrorPage:The page or resource you were trying to reach is forbidden for some reason. Reload the page to try again. `;

  localizedPageNotFound: string = $localize`:Page Not found Title text|Message header displayed when there is a Page not found@@appPageNotFoundInErrorPage:Page Not Found`;
  localizedPageNotFoundDesc: string = $localize`:Page not found description text|Message displayed when there is a Page ot found@@appPageNotFoundDescInErrorPage:Uh oh, we can't seem to find the page you're looking for. Try going back to previous page.`;

  localizedIntError: string = $localize`:Internal Server Error Title text|Message header displayed when there is a Internal Server Error@@appIntServerInErrorPage:Internal Server Error`;
  localizedIntErrorDesc: string = $localize`:Internal Server Error description text|Message displayed when there is a Internal Server Error@@appIntServertDescInErrorPage:Something went wrong at our end. We apologies and are fixing the problem. Please try again at a later stage. `;


  localizedBadGate: string = $localize`:Bad Gateway Title text|Message header displayed when there is a Bad Gateway@@appbadGateInErrorPage:Bad Gateway`;
  localizedBadGateDesc: string = $localize`:Bad Gateway description text|Message displayed when there is a Bad Gateway@@appbadGateDescInErrorPage:The server encountered a temporary error and could not complete your request. Please try again later. `;

  localizedServiceUn: string = $localize`:Service Unavailable Title text|Message header displayed when there is Service Unavailable@@appServiceUnavailInErrorPage:Survey Instruments is not available`;
  localizedServiceUnDesc: string = $localize`:Service Unavailable description text|Message displayed when there is Service Unavailable@@appServiceUnavailDescInErrorPage:Our system is currently unavailable, please try again later. `;

  localizedTimeOut: string = $localize`:Gateway Timeout Title text|Message header displayed when there is a Gateway Timeout@@appGateTimeInErrorPage:Gateway Timeout`;
  localizedTimeOutDesc: string = $localize`:Gateway Timeout description text|Message displayed when there is a Gateway Timeout@@appGateTimeDescInErrorPage:Something went wrong. The page can't be reached. Please try again after some time. `;

  errorsDetails: Map<number, ErrorsDetails> = new Map<number, ErrorsDetails>([
    [400, {
      title: this.localizedBadReq,
      description: this.localizedBadReqDesc,
      login: false
    }],
    [401, {
      title: this.localizedUnAuthor,
      description: this.localizedUnAuthorDesc,
      login: true
    }],
    [403, {
      title: this.localizedAccessDenied,
      description: this.localizedAccessDeniedDesc,
      login: true
    }],
    [404, {
      title: this.localizedPageNotFound,
      description: this.localizedPageNotFoundDesc,
      login: true
    }],
    [500, {
      title: this.localizedIntError,
      description: this.localizedIntErrorDesc,
      login: true
    }],
    [502, {
      title: this.localizedBadGate,
      description: this.localizedBadGateDesc,
      login: true
    }],
    [503, {
      title: this.localizedServiceUn,
      description: (environment.underMaintenance.headsup.enabled !== undefined)? environment.underMaintenance.headsup.statement[this._i18nService.selectedLocaleId as 'en-ca' | 'fr-ca'] :this.localizedServiceUnDesc,
      login: true
    }],
    [504, {
      title: this.localizedTimeOut,
      description: this.localizedTimeOutDesc ,
      login: true
    }],
  ])

  error!: ErrorsDetails;

  constructor(
    private _router: Router,
    private _i18nService: I18nService
  ) {}

  ngOnInit(): void {
    // get state that is passed by routing - access token per organization
    const errorState = this._router.lastSuccessfulNavigation?.extras.state as { errorCode: number };
    this.errorCode = errorState?.errorCode;
    if(!errorState) {
      this.error = this.errorsDetails.get(404)!
      return
    }
    try{
      this.error = this.errorsDetails.get(errorState.errorCode) ?? this.errorsDetails.get(404)! // 404 is a default error - guaranteed to be in the errorDetails
    }catch(e){
      this.error = {
        title: this.localizedPageNotFound,
        description: this.localizedPageNotFoundDesc,
        login: true
      };
    }
  }

  
}
